import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7f07a0c3 = () => interopDefault(import('../../../pages/help/index.vue' /* webpackChunkName: "pages/help/index" */))
const _2c3afee4 = () => interopDefault(import('../../../pages/import.vue' /* webpackChunkName: "pages/import" */))
const _073cc7ea = () => interopDefault(import('../../../pages/notification.vue' /* webpackChunkName: "pages/notification" */))
const _10cd717a = () => interopDefault(import('../../../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _3b9d8f48 = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _696423d6 = () => interopDefault(import('../../../pages/admin/notification/_id.vue' /* webpackChunkName: "pages/admin/notification/_id" */))
const _bc4d3182 = () => interopDefault(import('../../../pages/admin/song/_id.vue' /* webpackChunkName: "pages/admin/song/_id" */))
const _472b4692 = () => interopDefault(import('../../../pages/courses/_id/index.vue' /* webpackChunkName: "pages/courses/_id/index" */))
const _3722df32 = () => interopDefault(import('../../../pages/grade/_series/index.vue' /* webpackChunkName: "pages/grade/_series/index" */))
const _0422eedd = () => interopDefault(import('../../../pages/name/_nameIndex.vue' /* webpackChunkName: "pages/name/_nameIndex" */))
const _384a4b6a = () => interopDefault(import('../../../pages/nonstop/_series/index.vue' /* webpackChunkName: "pages/nonstop/_series/index" */))
const _4be21776 = () => interopDefault(import('../../../pages/series/_seriesIndex.vue' /* webpackChunkName: "pages/series/_seriesIndex" */))
const _69d6bebd = () => interopDefault(import('../../../pages/songs/_id/index.vue' /* webpackChunkName: "pages/songs/_id/index" */))
const _1a827572 = () => interopDefault(import('../../../pages/users/_id/index.vue' /* webpackChunkName: "pages/users/_id/index" */))
const _cab5f208 = () => interopDefault(import('../../../pages/users/_id/scores.vue' /* webpackChunkName: "pages/users/_id/scores" */))
const _17776e63 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _40617713 = () => interopDefault(import('../../../pages/_style/_level.vue' /* webpackChunkName: "pages/_style/_level" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/help",
    component: _7f07a0c3,
    name: "help"
  }, {
    path: "/import",
    component: _2c3afee4,
    name: "import"
  }, {
    path: "/notification",
    component: _073cc7ea,
    name: "notification"
  }, {
    path: "/profile",
    component: _10cd717a,
    name: "profile"
  }, {
    path: "/users",
    component: _3b9d8f48,
    name: "users"
  }, {
    path: "/admin/notification/:id?",
    component: _696423d6,
    name: "admin-notification-id"
  }, {
    path: "/admin/song/:id?",
    component: _bc4d3182,
    name: "admin-song-id"
  }, {
    path: "/courses/:id",
    component: _472b4692,
    name: "courses-id"
  }, {
    path: "/grade/:series",
    component: _3722df32,
    name: "grade-series"
  }, {
    path: "/name/:nameIndex?",
    component: _0422eedd,
    name: "name-nameIndex"
  }, {
    path: "/nonstop/:series",
    component: _384a4b6a,
    name: "nonstop-series"
  }, {
    path: "/series/:seriesIndex?",
    component: _4be21776,
    name: "series-seriesIndex"
  }, {
    path: "/songs/:id",
    component: _69d6bebd,
    name: "songs-id"
  }, {
    path: "/users/:id",
    component: _1a827572,
    name: "users-id"
  }, {
    path: "/users/:id/scores",
    component: _cab5f208,
    name: "users-id-scores"
  }, {
    path: "/",
    component: _17776e63,
    name: "index"
  }, {
    path: "/:style/:level?",
    component: _40617713,
    name: "style-level"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
